export enum ApprovalLine {
  FIRST = 'first',
  SECOND = 'second',
}

export interface LineApprovalStatus {
  status: DueDiligenceStatus | undefined;
  isLoading: boolean;
}

export enum DueDiligenceStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}
